import React, { Component } from "react";
import Pager from "./Pager/Pager";
export default class Pagination extends Component {
    constructor() {
        super(...arguments);
        this.state = {
            pageIndex: 0
        };
        this._handlePageChange = (pageIndex) => this.setState({ pageIndex });
    }
    render() {
        const { props } = this;
        const pageCount = Math.max(Math.ceil(props.items.length / props.itemsPerPage), 1);
        let { pageIndex } = this.state;
        pageIndex = Math.max(pageIndex, 0);
        pageIndex = Math.min(pageIndex, pageCount - 1);
        const itemIndex = props.itemsPerPage * pageIndex;
        const page = props.items.slice(itemIndex, itemIndex + props.itemsPerPage);
        const pagerProps = {
            pageIndex,
            pageCount,
            onChangePage: this._handlePageChange
        };
        return props.children({
            page,
            itemIndex,
            renderPager: srLabel => pageCount > 1 && (<Pager srLabel={srLabel} {...pagerProps}/>),
            ...pagerProps
        });
    }
}



// WEBPACK FOOTER //
// ./src/assets/scripts/components/presentational/Pagination/Pagination.tsx